import { getDelayAction } from 'automaton/actions/DelayAction'
import { getReelSpinAction } from 'automaton/actions/ReelSpinAction'
import { getRequestBuyAction } from 'automaton/actions/RequestBuyAction'
import { getRequestSpinAction } from 'automaton/actions/RequestSpinAction'
import { getBetState } from 'automaton/states/BetState'
import { getCascadeState } from 'automaton/states/CascadeState'
import { getFreeBetState } from 'automaton/states/FreeBetState'
import { getRespinState } from 'automaton/states/RespinState'
import { getWinState } from 'automaton/states/WinState'
import { spinSettings } from 'settings/custom/reels'

export function getSpinState() {
  game.models.ModeModel.respinIntro = true

  const winModel = game.models.WinModel.get()
  const spinModel = game.models.SpinModel.get()
  const freeBetModel = game.models.FreebetsModel.get()
  const cascadeModel = game.models.CascadeModel.get()
  const name = 'SPIN'
  if (spinSettings.hasOwnProperty('gamble') && spinSettings.gamble) {
    game.models.GambleModel.setIsGamble(false)
  }

  const actions = [
    game.models.ModeModel.buyFeature
      ? getRequestBuyAction()
      : getRequestSpinAction(),
    game.models.GameModel.requestAgainAllowed
      ? getDelayAction(0.1)
      : getReelSpinAction(),
  ]
  const transition = () =>
    game.models.GameModel.requestAgainAllowed
      ? getBetState()
      : cascadeModel.all > -1
        ? getCascadeState()
        : winModel.linesWin
          ? getWinState()
          : spinModel.respin.length
            ? getRespinState()
            : freeBetModel.rest
              ? getFreeBetState()
              : getBetState()

  return {
    name,
    actions,
    transition,
  }
}
